import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { id: "page" }
const _hoisted_2 = { class: "container-fluid breadcrumbs d-none d-md-block" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { "aria-label": "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = { href: "#/" }
const _hoisted_10 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_11 = {
  id: "main",
  class: ""
}
const _hoisted_12 = { class: "container px-xs-0 beratung" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "login-heading" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "login-content logged-in" }
const _hoisted_17 = { class: "login-content--subnav" }
const _hoisted_18 = { class: "login-content--main flow" }
const _hoisted_19 = { class: "h1" }
const _hoisted_20 = {
  key: 0,
  class: "form-text alert alert-danger"
}
const _hoisted_21 = {
  key: 1,
  class: "form-text"
}
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-12 col-lg-7 mb-7 mb-lg-0" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { for: "message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("nav", _hoisted_6, [
              _createElementVNode("ol", _hoisted_7, [
                _cache[5] || (_cache[5] = _createElementVNode("li", { class: "breadcrumb-item" }, [
                  _createElementVNode("a", { href: "#" }, "Home")
                ], -1)),
                _createElementVNode("li", _hoisted_8, [
                  _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.$t('views.appointment.termine')), 1)
                ]),
                _createElementVNode("li", _hoisted_10, _toDisplayString(_ctx.$t('views.appointment.cancel')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("main", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _cache[6] || (_cache[6] = _createElementVNode("i", {
              "aria-hidden": "true",
              class: "icon icon--user"
            }, null, -1)),
            _createElementVNode("div", null, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.$t('views.login.breadcrumbpage')), 1),
              _createElementVNode("small", _hoisted_15, [
                _createTextVNode(_toDisplayString(_ctx.$t('views.appointment.loggedinas')) + " " + _toDisplayString(_ctx.user) + " ", 1),
                _createElementVNode("a", {
                  class: "ms-1",
                  href: "#",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                }, _toDisplayString(_ctx.$t('views.appointment.logout')), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("ul", _hoisted_17, [
            _createElementVNode("li", {
              class: _normalizeClass(["login-content--subnav--item", { active: _ctx.isRouteActive('widget-appointment-cancel') }]),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navigateToAppointments && _ctx.navigateToAppointments(...args)))
            }, [
              _cache[7] || (_cache[7] = _createElementVNode("i", {
                "aria-hidden": "true",
                class: "icon icon--calendar"
              }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('views.appointment.termine')), 1)
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass(["login-content--subnav--item", { active: _ctx.isRouteActive('widget-account') }]),
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.navigateToAccount && _ctx.navigateToAccount(...args)))
            }, [
              _cache[8] || (_cache[8] = _createElementVNode("i", {
                "aria-hidden": "true",
                class: "icon icon--user"
              }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('views.appointment.account')), 1)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("h2", _hoisted_19, _toDisplayString(_ctx.$t('views.appointment.cancel')), 1),
            (_ctx.error != '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true),
            (_ctx.success != '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.success), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('views.appointment.note')), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    name: "note",
                    i18nLabel: "views.appointment.noteClient",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.note) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.note]
                  ])
                ]),
                _createElementVNode("button", {
                  class: "btn btn-primary-custom mt-3 mb-4",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
                }, _toDisplayString(_ctx.$t('views.appointment.cancel')), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}